// (function () {
//     'use strict';

//     const module = angular.module('imApp');

//     module.component('specialCustProdCalc', {
//         templateUrl: 'views/components/views/specialCustProdCalc/specialCustProdCalc.template.html?v=' + module.version,
//         controllerAs: 'vm',
//         controller: ['$stateParams', 'utilityService', 'specialCustProdCalcService', function ($stateParams, utilityService, specialCustProdCalcService) {

//             // #region VARIABLES & DEFINITIONS
            
//             const vm = this;
//             let custNo = $stateParams.cust_no;

//             vm.model = {
//                 productId: '',
//                 calculation: {},
//                 selectListProducts: [],
//                 inputListPrices: []
//             };

//             // #endregion VARIABLES & DEFINITIONS

//             // #region LOAD PROCEDURE CALLS
            
//             async function loadProducts() {
//                 vm.model.selectListProducts = await specialCustProdCalcService.listProducts();

//                 vm.model.selectListProducts.forEach((item) => {
//                     if (item?.prod_id && item.prod_id > '') {
//                         vm.model.productId = item.prod_id;
//                     }
//                 }); 
//             }

//             async function retrieveCalculation() {
//                 if (utilityService.validateParmsValue(vm.model.productId) !== true) return;

//                 vm.model.calculation = (await specialCustProdCalcService.getCalculation({
//                     cust_no: custNo,
//                     prod_id: vm.model.productId
//                 }))[0];
//             }

//             async function retrievePrices() {
//                 if (utilityService.validateParmsValue(vm.model.productId) !== true) return;
//                 if (utilityService.validateParmsValue(vm.model.calculation.price) !== true) return;
//                 if (utilityService.validateParmsValue(vm.model.calculation.discount) !== true) return;
//                 if (utilityService.validateParmsValue(vm.model.calculation.bonus) !== true) return;
//                 if (utilityService.validateParmsValue(vm.model.calculation.sold_freight) !== true) return;
//                 if (utilityService.validateParmsValue(vm.model.calculation.weight) !== true) return;
//                 if (utilityService.validateParmsValue(vm.model.calculation.postplace_id) !== true) return;

//                 if (vm.model.calculation.discount !== '' && vm.model.calculation.sold_freight !== '') {
//                     vm.model.inputListPrices = await specialCustProdCalcService.listPrices({
//                         cust_no: custNo,
//                         prod_id: vm.model.productId,
//                         price: utilityService.parseNumber(vm.model.calculation.price),
//                         discount: utilityService.parseNumber(vm.model.calculation.discount),
//                         bonus: utilityService.parseNumber(vm.model.calculation.bonus),
//                         sold_freight: utilityService.parseNumber(vm.model.calculation.sold_freight),
//                         weight: utilityService.parseNumber(vm.model.calculation.weight),
//                         postplace_id: vm.model.calculation.postplace_id
//                     });
//                 }
//             }

//             // #endregion LOAD PROCEDURE CALLS

//             // #region FIELD CHANGE PRODUCT FUNCTION

//             vm.onProductChanged = async function (value) {
//                 if (utilityService.validateWatchValue(value, vm.model.productId) !== true) return;

//                 vm.model.productId = value;

//                 if (utilityService.validateParmsValue(vm.model.productId) !== true) return;

//                 await retrieveCalculation();
//                 retrievePrices();
//             }

//             // #endregion FIELD CHANGE PRODUCT FUNCTION

//             // #region ON BLUR MULTI FUNCTIONS

//             vm.onCalculationBlur = function (id) {
//                 switch (id) {
//                     case 'discount':
//                     case 'sold_freight':
//                     case 'postplace_id':
//                         if (utilityService.validateParmsValue(vm.model.calculation[id], true) !== true) return;

//                         retrievePrices();
//                         break;
//                     default:
//                         break;
//                 }
//             };

//             // #endregion ON BLUR MULTI FUNCTIONS

//             // #region ON INIT FUNCTION

//             vm.$onInit = async function () {
//                 await loadProducts();
                
//                 Promise.all([
//                     retrieveCalculation()
//                 ]).then(() => {
//                     retrievePrices();
//                     Promise.resolve();
//                 });
//             }

//             // #endregion ON INIT FUNCTION

//         }]
//     });
// })();
